import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/CsHome.css";
import SearchIcon from "@mui/icons-material/Search";
import HeadPhone from "../assets/images/headphones.png";
import CircularProgress from "@mui/material/CircularProgress"; // استيراد مؤشر التحميل الدائري

const CsHome = () => {
  const [loading, setLoading] = useState(false);
  const [shipmentNumber, setShipmentNumber] = useState(""); // لحفظ رقم الشحنة المدخل
  const [shipmentDetails, setShipmentDetails] = useState(null); // لحفظ نتيجة الـ API
  const [error, setError] = useState(null); // لحفظ الخطأ إذا وُجد
  const navigate = useNavigate();

  const handleSearch = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!shipmentNumber) {
      alert("Please enter a shipment number!");
      return;
    }

    setLoading(true); // تفعيل حالة التحميل

    try {
      const response = await axios.get(
        `https://tarabotcs.com-eg.net/api/Agent/V1/GetShipmentDetailsEx/${shipmentNumber}`,
        {
          headers: {
            CompanyID: userData.Data.CompanyID,
            AccessToken: userData.Data.AccessToken,
          },
        }
      );

      if (response.data && response.data.Success) {
        const shipmentDetails = response.data.Data?.data?.ShipmentInfo;
        const shipmentTracking = response.data.Data?.data?.Tracking;
        const shipmentComplaint = response.data.Data?.data?.Complaints;
        const ComplaintsActions = response.data.Data?.data?.ComplaintsActions;

        if (shipmentDetails?.length > 0) {
          navigate("/shipment-details", {
            state: {
              shipmentDetails,
              shipmentTracking,
              shipmentComplaint,
              ComplaintsActions,
            },
          });
          setShipmentDetails(shipmentDetails[0]);
          setError(null);
        } else {
          setError("No shipment details found.");
          setShipmentDetails(null);
        }
      } else {
        setError("Failed to fetch shipment details. Please try again.");
        setShipmentDetails(null);
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch shipment details. Please try again.");
      setShipmentDetails(null);
    } finally {
      setLoading(false); // إيقاف حالة التحميل
    }
  };

  const handleRetry = () => {
    setError(null);
    navigate("/general-inquiry");
  };

  const handleGoHome = () => {
    navigate("/data-entry");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="home-container">
      <div className="container">
        <div className="logo">
          <img src={HeadPhone} alt="Call Center Logo" />
        </div>
        <div className="search-box">
          <button
            className="search-button"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              <SearchIcon style={{ color: "white" }} />
            )}
          </button>
          <input
            type="text"
            className="search-input"
            placeholder="Enter Shipment Number"
            value={shipmentNumber}
            onChange={(e) => setShipmentNumber(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />
        </div>

        {loading && (
          <div className="loading-container">
            <CircularProgress size={50} style={{ color: "#007bff" }} />
          </div>
        )}

        {shipmentDetails && (
          <div className="shipment-details">
            <h3>Shipment Details:</h3>
            <pre>{JSON.stringify(shipmentDetails, null, 2)}</pre>
          </div>
        )}

        {error && (
          <div className="error-actions">
            <button className="retry-button" onClick={handleRetry}>
              General Inquiry
            </button>
            <button className="home-button" onClick={handleGoHome}>
              Add Data
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CsHome;
